import { api } from '@wellesley/openapi'
import { handleBasicResponse } from '@wellesley/openapi/helpers'

export const searchApi = api.enhanceEndpoints({
  endpoints: {
    getApiV1Search: {
      providesTags: ['Global_Search'],
      async onQueryStarted(_, { queryFulfilled }) {
        await handleBasicResponse(queryFulfilled)
      },
    },
  },
})

export const { useGetApiV1SearchQuery } = searchApi
